import { isWeChat, isAndroid, isFacebook } from './getDevice'
import GuideBrowser from '@/components/guide-browser'

interface QueryOpt {
  [x: string]: any
}

const appInstall = function(
  router: string = '/router/sell/index',
  queryOpt: QueryOpt = {}
): void {
  if (isWeChat || isFacebook) {
    GuideBrowser.show()
    return
  }
  let queryStr = encodeURIComponent(
    Object.keys(queryOpt)
      .map((key) => `${key}=${queryOpt[key]}`)
      .join('&')
  )
  queryStr = queryStr ? `?${queryStr}` : ''
  const link = `https://hk.poizon.com${router}${queryStr}`

  const diffStr = isAndroid
    ? '&apn=com.shizhuang.poizon.hk'
    : '&ibi=com.shizhuang.poizon.hk&isi=1509915974&efr=1'

  // const diffHost = isAndroid
  //   ? 'https://poizon2hk.page.link'
  //   : 'applinks:poizon2hk.page.link'

  const diffHost = 'https://poizon2hk.page.link'

  top.location.href = `${diffHost}/?link=${link}${diffStr}`
}

export default appInstall
